// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RG_F","colMin":"styles_colMin__ZiBwa"};